import type { AuthorshipEvidenceModel } from "@/api/cle-api";
import { UserQueryContext } from "@/context/UserContext";
import { formatLessons } from "@/util/number";
import { useContext } from "react";

import { DetailItem } from "../person/id/Efteruddannelse/DetailItem";
import { AuthorshipValidationEditModal } from "./AuthorshipValidationEditModal";

interface AuthorshipValidationProps {
  authorship: AuthorshipEvidenceModel;
  onAuthorshipUpdated?: (updated: AuthorshipEvidenceModel) => void;
}

export const AuthorshipValidation = ({
  authorship,
  onAuthorshipUpdated,
}: AuthorshipValidationProps) => {
  const { user, hasPermission } = useContext(UserQueryContext);
  // Reported (indberettet) evidence backs a signed declaration and is immutable;
  // the API refuses these edits with 409 EVIDENCE_ALREADY_REPORTED.
  const canEdit = hasPermission(user, "TilsynWrite") && !authorship.isReported;

  const handleSave = (updated: AuthorshipEvidenceModel) => {
    onAuthorshipUpdated?.(updated);
  };

  return (
    <div className="c-card c-item-list">
      <div className="flex-100 d-flex justify-content-between flex-row align-items-center">
        <h3 className="mb-0">Publikationsoplysninger</h3>
        {canEdit && (
          <AuthorshipValidationEditModal
            authorship={authorship}
            onSave={handleSave}
          />
        )}
      </div>
      <div className="d-flex flex-column gap-2">
        <DetailItem label="Titel" value={authorship.bookTitle || "-"} />
        <DetailItem label="Forlag" value={authorship.publisher || "-"} />
        <DetailItem
          label="Udgivelsesår"
          value={authorship.publicationYear ?? "-"}
        />
        <DetailItem label="ISBN" value={authorship.isbn ?? "-"} />
        <DetailItem
          label="Antal lektioner"
          value={formatLessons(authorship.numberOfLessons)}
        />
      </div>
    </div>
  );
};
